/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { gatewaySessionsList } from "../funcs/gatewaySessionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListGatewaySessionsRequest,
  ListGatewaySessionsResponse,
  ListGatewaySessionsSecurity,
  Sort,
  Status,
} from "../models/operations/listgatewaysessions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type GatewaySessionsQueryData = ListGatewaySessionsResponse;

export type GatewaySessionsInfiniteQueryData = PageIterator<
  ListGatewaySessionsResponse,
  { cursor: string }
>;

export type GatewaySessionsPageParams = PageIterator<
  ListGatewaySessionsResponse,
  { cursor: string }
>["~next"];

export function prefetchGatewaySessions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGatewaySessionsRequest | undefined,
  security?: ListGatewaySessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGatewaySessionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchGatewaySessionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGatewaySessionsRequest | undefined,
  security?: ListGatewaySessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildGatewaySessionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as GatewaySessionsPageParams,
    getNextPageParam: (previousPage: GatewaySessionsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildGatewaySessionsQuery(
  client$: GramCore,
  request?: ListGatewaySessionsRequest | undefined,
  security?: ListGatewaySessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GatewaySessionsQueryData>;
} {
  return {
    queryKey: queryKeyGatewaySessions({
      gatewayId: request?.gatewayId,
      search: request?.search,
      serverId: request?.serverId,
      providerId: request?.providerId,
      status: request?.status,
      createdAfter: request?.createdAfter,
      createdBefore: request?.createdBefore,
      sort: request?.sort,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function gatewaySessionsQueryFn(
      ctx,
    ): Promise<GatewaySessionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(gatewaySessionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildGatewaySessionsInfiniteQuery(
  client$: GramCore,
  request?: ListGatewaySessionsRequest | undefined,
  security?: ListGatewaySessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, GatewaySessionsPageParams>,
  ) => Promise<GatewaySessionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyGatewaySessionsInfinite({
      gatewayId: request?.gatewayId,
      search: request?.search,
      serverId: request?.serverId,
      providerId: request?.providerId,
      status: request?.status,
      createdAfter: request?.createdAfter,
      createdBefore: request?.createdBefore,
      sort: request?.sort,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function gatewaySessionsQuery(
      ctx,
    ): Promise<GatewaySessionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(gatewaySessionsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(gatewaySessionsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyGatewaySessions(
  parameters: {
    gatewayId?: string | undefined;
    search?: string | undefined;
    serverId?: string | undefined;
    providerId?: string | undefined;
    status?: Status | undefined;
    createdAfter?: Date | undefined;
    createdBefore?: Date | undefined;
    sort?: Sort | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "gatewaySessions", "list", parameters];
}

export function queryKeyGatewaySessionsInfinite(
  parameters: {
    gatewayId?: string | undefined;
    search?: string | undefined;
    serverId?: string | undefined;
    providerId?: string | undefined;
    status?: Status | undefined;
    createdAfter?: Date | undefined;
    createdBefore?: Date | undefined;
    sort?: Sort | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "gatewaySessions", "list", "infinite", parameters];
}
